import API from "./baseApi";

const getAllMembershipPlans = (payload) => {
  if (payload && Object.keys(payload).length) {
    let query = "?";
    Object.keys(payload).forEach((key) => {
      query += `${key}=${payload[key]}&`;
    });
    return API.get(`/membershipPlans${query}`, payload);
  }

  return API.get("/membershipPlans", payload);
};

const createMembershipPlan = (payload) => {
  return API.post("/membershipPlans", payload);
};

const updateMembershipPlan = (id, payload) => {
  return API.put(`/membershipPlans/${id}`, payload);
};

const deleteMembershipPlan = (id, payload) => {
  return API.delete(`/membershipPlans/${id}`, payload);
};

const getAllTenants = () => {
  return API.get("/membershipPlans/getTenants");
};

const getAllCountries = (payload = {}) => {
  return API.post("/countries/allData", payload);
};

const getSecurityProviders = () => {
  return API.get("/security-providers");
};

export default {
  getAllMembershipPlans,
  createMembershipPlan,
  updateMembershipPlan,
  deleteMembershipPlan,
  getAllTenants,
  getAllCountries,
  getSecurityProviders,
};